// extracted by mini-css-extract-plugin
export var btn = "dialog-module--btn--XsRro";
export var cont = "dialog-module--cont--uJdLv";
export var dialogcontent = "dialog-module--dialogcontent--P58py";
export var headline = "dialog-module--headline--yUv35";
export var root = "dialog-module--root--yRI72";